<nav class="navbar head-nav">
  <h2 *ngIf="!dataLoading" [matTooltip]="details.labName" matTooltipClass="wrap-tooltip">
    {{
    isOurProfile ? ('labProfile.centerProfile'|translate) :
    (isOurProfile || isOurProfileVl) ? ('labProfile.educationalCenterProfile'|translate) : details.labName
    }}
  </h2>
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]='["/"]'>{{"general.home"|translate}}</a></li>
    <li class="breadcrumb-item">
      {{
      isOurProfile ? ('labProfile.centerProfile'|translate) :
      hasPermission('HospitalAdmin') ||
      hasPermission('ClinicAdmin')?('labProfile.educationalCenterS'|translate):('sideBar.restaurants'|translate)
      }}
    </li>
  </ol>
</nav>

<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div class="lab_profile" *ngIf="(!dataLoading && (isOurProfile || isOurProfileVl)) || (!dataLoading && labId)">
  <div class="profile_wrapper_header">
    <div class="profile_inner_left">
      <div class="profile_image">
        <img [src]="details.logo" (error)='details.logo = "assets/images/lab/default_avatar.svg"' />
        <!-- <span>MS</span> -->
      </div>
      <div class="profile_content_left">
        <div class="profile_content_left_name"
          *ngIf="details.labType === 'BRANCH' || details.labType === 'HOSPITAL_LAB' || details.labType === 'CLINIC_LAB'">
          <span>
            {{
            details.labType === 'HOSPITAL_LAB'?('labProfile.labOfHospital'|translate):
            details.labType === 'CLINIC_LAB'?('labProfile.labOfClinic'|translate):('labProfile.branchOf'|translate)
            }}
          </span>
          <div class="profile_content_left_name_inner">
            <ng-container *ngIf="details.labType !== 'BRANCH'; else labBranch">
              <img [src]="details.entity.logoUrl"
                (error)="details.entity.logoUrl = './assets/images/lab/default_avatar.svg'" alt="branche">
              <h5>{{details.entity.entityName}}</h5>
            </ng-container>
            <ng-template #labBranch>
              <img [src]="details.mainLab.logo"
                (error)="details.mainLab.logo = './assets/images/lab/default_avatar.svg'" alt="branche">
              <h5>{{details.mainLab.name}}</h5>
            </ng-template>
          </div>
        </div>
        <h4>{{details.labName}}</h4>
        <div class="create_date">
          {{"general.createdOn"|translate}}: <span>{{details.createdOn | date:'d MMM, y, h:mm a'}}</span>
        </div>
      </div>
    </div>
    <div class="profile_inner_right">
      <button appAccessControl accessRoles="SuperAdmin" mat-icon-button [matTooltip]="'Delete'"
        (click)="deleteRecord(labId)" *ngIf="!isOurProfileVl && details.canDeleteLab">
        <svg width="16" height="20.002" viewBox="0 0 16 20.002">
          <path id="delete-icon"
            d="M4422.4,17833.639a1.853,1.853,0,0,1-1.844-1.785l-.51-10.822a.2.2,0,0,1,.192-.207H4433.9a.194.194,0,0,1,.192.207l-.505,10.822a1.859,1.859,0,0,1-1.844,1.785Zm7.134-11.252v8.129a.616.616,0,1,0,1.231,0v-8.129a.616.616,0,1,0-1.231,0Zm-3.079,0v8.129a.615.615,0,1,0,1.23,0v-8.129a.615.615,0,1,0-1.23,0Zm-3.075,0v8.129a.615.615,0,1,0,1.23,0v-8.129a.615.615,0,1,0-1.23,0Zm-3.692-2.811a.621.621,0,0,1-.618-.627v-1.248a1.551,1.551,0,0,1,1.54-1.562h3.383v-.627a1.864,1.864,0,0,1,1.849-1.875h2.461a1.86,1.86,0,0,1,1.844,1.875v.627h3.383a1.551,1.551,0,0,1,1.54,1.563v1.248a.617.617,0,0,1-.613.627Zm5.536-4.064v.627h3.692v-.627a.616.616,0,0,0-.613-.621h-2.461A.619.619,0,0,0,4425.223,17815.512Z"
            transform="translate(-4419.069 -17813.637)" fill="#616e7c" />
        </svg>
      </button>
      <a class="button_with_icon" appAccessControl accessRoles="SuperAdmin,LabAdmin,VLAdmin,HospitalAdmin,ClinicAdmin"
        mat-raised-button color="primary" (click)="openLabForm(false)">
        <svg width="16" height="16.004" viewBox="0 0 16 16.004">
          <path id="edit-icon"
            d="M5.82,14l-3.63-3.63,8.78-8.78,3.63,3.63ZM1.851,11.011l3.33,3.33L.188,16Zm13.865-6.9-.63.63L11.451,1.1l.63-.63a1.624,1.624,0,0,1,2.3,0l1.338,1.338a1.633,1.633,0,0,1,0,2.3Zm0,0"
            transform="translate(-0.188 0.001)" />
        </svg>
        <span class="value">{{"general.edit"|translate}}</span>
      </a>
    </div>
  </div>
  <div class="row">

    <div class="col-xl-6 col-lg-12 col-md-12 card_info_profile">
      <div class="card_info_profile_content">
        <div class="card_info_profile_title">
          <h4>{{"labProfile.basicInfo"|translate}}</h4>
        </div>
        <div class="card_info_profile_body">
          <ul class="list_with_icons">
            <!-- <li>
              <div class="icon">
                <img src="assets/images/icons/manager-icon.svg" alt="">
              </div>
              <div class="content">
                <h4>{{"general.manager"|translate}}</h4>
                <p>{{details.basicInfo?.managerName}}</p>
              </div>
            </li> -->
            <li>
              <div class="icon">
                <img src="assets/images/icons/phone-icon.svg" alt="">
              </div>
              <div class="content d-flex align-items-center justify-content-between flex-grow-1">
                <div class="flex-grow-1">
                  <h4>{{"general.mobileNo"|translate}}</h4>
                  <p class="always-ltr">{{details.basicInfo.contactNumberExtension + ' ' +
                    details.basicInfo.contactNumber}}
                  </p>
                </div>
                <!-- <div class="conatnier_actions">
                  <ng-container *ngIf="!details.basicInfo.isMobileVerified">
                    <span class="badge_status_progress orange">
                      {{"general.mobileNotVerified"|translate}}
                    </span>
                    <a class="button_with_icon" mat-raised-button color="primary" appAccessControl
                      accessRoles="SuperAdmin,,VLAdmin,LabAdmin,ScanningCenterAdmin,HospitalAdmin,ClinicAdmin"
                      (click)="verifyMobile()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19.008" viewBox="0 0 16 19.008">
                        <g id="verify-icon" transform="translate(-8.887 -2.496)" opacity="0.85">
                          <path id="Path_17564" data-name="Path 17564"
                            d="M54.572,2.915,47.766.054a.686.686,0,0,0-.533,0L40.428,2.915A.7.7,0,0,0,40,3.564V7.042a11.776,11.776,0,0,0,7.238,10.906.687.687,0,0,0,.525,0A11.776,11.776,0,0,0,55,7.042V3.564A.7.7,0,0,0,54.572,2.915Zm-.961,4.127A10.377,10.377,0,0,1,47.5,16.533a10.377,10.377,0,0,1-6.111-9.491V4.034L47.5,1.465l6.111,2.569Z"
                            transform="translate(-30.613 3)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1"
                            opacity="0.7" />
                          <path id="Path_17565" data-name="Path 17565"
                            d="M46.732,9.412,49.717,6.39a.688.688,0,0,1,.982,0,.709.709,0,0,1,0,.994L47.223,10.9a.688.688,0,0,1-.982,0L44.3,8.939a.709.709,0,0,1,0-.994.688.688,0,0,1,.982,0Z"
                            transform="translate(-30.613 3)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1" />
                        </g>
                      </svg>
                      <span class="value">{{"general.verifyNow"|translate}}</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="details.basicInfo.isMobileVerified">
                    <span class="badge_status_progress success">
                      {{"general.mobileNoVerified"|translate}}
                    </span>
                  </ng-container>

                </div> -->
              </div>
            </li>
            <li>
              <div class="icon">
                <img src="assets/images/icons/email_address.svg" alt="">
              </div>
              <div class="content d-flex align-items-center justify-content-between flex-grow-1">
                <div class="flex-grow-1">
                  <h4>{{"general.emailAddress"|translate}}</h4>
                  <p>{{details.basicInfo.email}}</p>
                </div>
                <div class="conatnier_actions">
                  <ng-container *ngIf="!details.basicInfo.isEmailVerified">
                    <span class="badge_status_progress orange">
                      {{"general.emailNotVerified"|translate}}
                    </span>
                    <a class="button_with_icon" mat-raised-button color="primary" appAccessControl
                      accessRoles="SuperAdmin,VLAdmin,LabAdmin,ScanningCenterAdmin,HospitalAdmin,ClinicAdmin"
                      (click)="verfiyEmail()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19.008" viewBox="0 0 16 19.008">
                        <g id="verify-icon" transform="translate(-8.887 -2.496)" opacity="0.85">
                          <path id="Path_17564" data-name="Path 17564"
                            d="M54.572,2.915,47.766.054a.686.686,0,0,0-.533,0L40.428,2.915A.7.7,0,0,0,40,3.564V7.042a11.776,11.776,0,0,0,7.238,10.906.687.687,0,0,0,.525,0A11.776,11.776,0,0,0,55,7.042V3.564A.7.7,0,0,0,54.572,2.915Zm-.961,4.127A10.377,10.377,0,0,1,47.5,16.533a10.377,10.377,0,0,1-6.111-9.491V4.034L47.5,1.465l6.111,2.569Z"
                            transform="translate(-30.613 3)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1"
                            opacity="0.7" />
                          <path id="Path_17565" data-name="Path 17565"
                            d="M46.732,9.412,49.717,6.39a.688.688,0,0,1,.982,0,.709.709,0,0,1,0,.994L47.223,10.9a.688.688,0,0,1-.982,0L44.3,8.939a.709.709,0,0,1,0-.994.688.688,0,0,1,.982,0Z"
                            transform="translate(-30.613 3)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1" />
                        </g>
                      </svg>
                      <span class="value">{{"general.verifyNow"|translate}}</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="details.basicInfo.isEmailVerified">
                    <span class="badge_status_progress success">
                      {{"general.emailVerified"|translate}}
                    </span>
                  </ng-container>
                </div>

              </div>
            </li>
            <li>
              <div class="icon">
                <img src="assets/images/icons/map-marker-icon.svg" alt="">
              </div>
              <div class="content">
                <h4>{{"general.address"|translate}}</h4>
                <p>
                  {{details.basicInfo.address}}
                </p>
                <p>
                  {{details.city.name}}, {{details.region.name}}
                </p>
                <p>
                  {{details.country.name}}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-xl-6 col-lg-12 col-md-12 card_info_profile title-has-btns revert"
      *ngIf="!isOurProfile && !isOurProfileVl">
      <app-users-list-shared [entityType]='modelsEnum.Lab' [entityId]='labId'>
      </app-users-list-shared>
    </div>

  </div>
</div>